import React, { Component } from "react";
import PropTypes from "prop-types";
import { ID_PREFIX_BOX, ID_PREFIX_PAGE, PAGE_TYPES } from "../../../../common/constants";
import i18n from "i18next";
import { templates } from "./templates/templates";
import "./_templatesModal.scss";
import AppModal from "../../common/modal/AppModal";
import { createBox } from "../../../../common/common_tools";
import { isClmAllowedPlugin } from "../../../../common/clm";

// Uploaded ("save as template") scenes store their boxes as a JSON string
// with `<!>` standing in for `"` (see EditorApp.uploadTemplate / duplicateNavItemByPayload).
// CLM courses only offer entries whose boxes are all allowlisted plugins.
export const isUploadedTemplateClmAllowed = (item) => {
  try {
    const boxes = JSON.parse((item.boxes || "[]").replaceAll("<!>", '"'));
    return boxes.every((box) => {
      const pluginId = box.pluginToolbar && box.pluginToolbar.pluginId;
      return !pluginId || isClmAllowedPlugin(pluginId);
    });
  } catch (e) {
    return false;
  }
};

export default class UploadedTemplatesModal extends Component {
  constructor(props) {
    super(props);
    this.index = 0;
    this.templates = templates();

    /**
     * Component's initial state
     */

    this.state = {
      itemSelected: -1,
      uploadedTemplates: [],
      selectedPageIndex: -1,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.show && nextProps.show) {
    }
  }

  render() {
    // The store is preloaded with `uploadedTemplates: {}` (core/store/state.es6)
    // and the reducer only replaces it once a template is saved/imported, so the
    // prop is an object-keyed map on a fresh load — never assume an array here.
    const uploaded = this.props.uploadedTemplates || [];
    const visibleTemplates = (Array.isArray(uploaded) ? uploaded : Object.values(uploaded))
      .map((item, index) => ({ item, index }))
      .filter(({ item }) => !this.props.isClm || isUploadedTemplateClmAllowed(item));
    const hasTemplates = visibleTemplates.length > 0;

    return (
      <AppModal
        id="UploadedTemplatesModal"
        show={this.props.show}
        onClose={() => this.closeModal()}
        title={<span id="previewTitle">{i18n.t("marks.template_uploaded_slide")}</span>}
        size="lg"
        backdrop="static"
        cancelLabel={
          hasTemplates ? i18n.t("importFile.footer.cancel") : i18n.t("importFile.footer.ok")
        }
        onCancel={() => this.closeModal()}
        confirmLabel={hasTemplates ? i18n.t("Use") : undefined}
        onConfirm={() => {
          this.props.onNavItemDuplicatedByPayload(this.state.selectedPageIndex);
          this.closeModal();
        }}
      >
        <div className="items_container">
          {hasTemplates ? (
            visibleTemplates.map(({ item, index }) => {
              const border =
                this.state.itemSelected === index ? "solid #a963f5 3px" : "solid #b0b2b6 1px";

              return (
                <div
                  onClick={() => {
                    this.setState({ itemSelected: index, selectedPageIndex: index });
                  }}
                  onDoubleClick={() => {
                    this.setState({ itemSelected: index });
                    this.props.onNavItemDuplicatedByPayload(index);
                    this.closeModal();
                  }}
                  key={index}
                  className="template_item"
                  style={{ position: "relative", border, width: "120px", height: "80px" }}
                >
                  <img style={{ height: "100%", width: "100%" }} src="./images/Sablon.png" />
                  <div className="template_name" style={{ display: "block" }}>
                    {item.name}
                  </div>
                </div>
              );
            })
          ) : (
            <p
              className="empty"
              style={{
                width: "100%",
                textAlign: "center",
                padding: "20px",
                color: "#a963f5",
                fontWeight: "bold",
              }}
            >
              {i18n.t("YouDontHaveAnyRecordedScenes")}
            </p>
          )}
        </div>
      </AppModal>
    );
  }

  /**
   * Close modal
   */
  closeModal() {
    // reset state
    this.setState({ itemSelected: -1 });
    this.props.close();
  }
  /**
   * Add Slide
   */
  AddNavItem(template) {
    let newId = "";

    if (
      this.props.navItems[this.props.navItems[this.props.indexSelected].parent] != null &&
      this.props.navItems[this.props.navItems[this.props.indexSelected].parent].children != null
    ) {
      let navItemIds = this.props.navItems[
        this.props.navItems[this.props.indexSelected].parent
      ].children.filter((r) => r.includes(ID_PREFIX_PAGE));

      if (
        navItemIds.indexOf(this.props.indexSelected) != -1 &&
        navItemIds.indexOf(this.props.indexSelected) != navItemIds.length - 1
      ) {
        let beforeNavNumber = Number(
          navItemIds[navItemIds.indexOf(this.props.indexSelected)].replace(ID_PREFIX_PAGE, "")
        );
        let afterNavNumber = Number(
          navItemIds[navItemIds.indexOf(this.props.indexSelected) + 1].replace(ID_PREFIX_PAGE, "")
        );

        if (afterNavNumber - beforeNavNumber == 1) {
          newId = ID_PREFIX_PAGE + (beforeNavNumber + 0.5);
        } else {
          newId = ID_PREFIX_PAGE + Math.floor((beforeNavNumber + afterNavNumber) / 2);
        }
      } else {
        newId = ID_PREFIX_PAGE + Date.now();
      }
    } else {
      newId = ID_PREFIX_PAGE + Date.now();
    }

    if (this.props.show) {
      this.props.onNavItemAdded(
        newId,
        i18n.t("slide"),
        // this.getParent().id,// Calculated in CarrouselButtons
        PAGE_TYPES.SLIDE,
        // this.props.calculatePosition(), // Calculated in CarrouselButtons
        "rgb(255,255,255)",
        0,
        template !== -1,
        false
      );
      if (template !== -1) {
        let selectedTemplate = this.templates[template];
        let boxes = selectedTemplate.boxes;

        boxes.map((item, index) => {
          let position = {
            x: item.box.x,
            y: item.box.y,
            type: "absolute",
          };
          let initialParams = {
            id: ID_PREFIX_BOX + Date.now() + "_" + index,
            parent: newId,
            container: 0,
            col: 0,
            row: 0,
            width: item.box.width,
            height: item.box.height,
            position: position,
            name: item.toolbar.name,
            isDefaultPlugin: true,
            page: newId,
          };
          if (item.toolbar.text) {
            initialParams.text = item.toolbar.text;
          } else if (item.toolbar.url) {
            initialParams.url = item.toolbar.url;
          }
          createBox(
            initialParams,
            item.toolbar.name,
            true,
            this.props.onBoxAdded,
            this.props.boxes,
            item.toolbar.style
          );
        });
      }
      // reset state
      this.setState({
        itemSelected: -1,
      });
      // this.props.onIndexSelected(newId);
      this.props.close();
    }
  }
}
UploadedTemplatesModal.propTypes = {
  /**
   * Whether the import file modal should be shown or hidden
   */
  show: PropTypes.bool,
  /**
   * Closes import file modal
   */
  close: PropTypes.func.isRequired,
  /**
   * Function for adding a new view
   */
  onNavItemAdded: PropTypes.func.isRequired,
  /**
   *  Object containing all created boxes (by id)
   */
  boxes: PropTypes.object.isRequired,
  /**
   * Function for adding a new box
   */
  onBoxAdded: PropTypes.func.isRequired,
  /**
   * Whether this is a CLM course — only allowlisted-plugin uploaded templates are offered
   */
  isClm: PropTypes.bool,
};
